import {
  IonButton,
  IonCardContent,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonGrid,
  IonIcon,
  IonPage,
  IonRow,
  IonText,
  IonToolbar,
} from "@ionic/react";
import { closeOutline } from "ionicons/icons";
import { useEffect, useMemo, useState } from "react";
import QRCode from "react-qr-code";
import Satoshi from "../assets/satoshi.svg";
import useVerifyPurchase from "../hooks/useVerifyPurchase";
import "./styles.css";

const centerText = { textAlign: "center" };
const subtitleStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  textTransform: "lowercase",
};
const marginRight5 = { marginRight: 5 };

const QRCodeModal = ({
  data,
  invoiceId,
  style = {},
  onClose,
  title,
  subtitle,
}) => {
  const [counter, setCounter] = useState(0);
  const invoice = useVerifyPurchase(invoiceId, counter);
  const qrCodeStyle = useMemo(
    () => ({
      width: 250,
    }),
    []
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCounter((s) => s + 1);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <IonPage>
      <div className={"qr-code-modal-root"}>
        <IonToolbar>
          <IonButton color={"dark"} fill={"clear"} onClick={onClose}>
            <IonIcon icon={closeOutline} />
          </IonButton>
        </IonToolbar>
        {data && (
          <div className={"main-content"} style={style}>
            <IonCardContent>
              <QRCode
                size={250}
                style={qrCodeStyle}
                value={typeof data === "string" ? data : JSON.stringify(data)}
              />
            </IonCardContent>
            <IonGrid>
              <IonRow>
                <IonCol>
                  <IonCardTitle style={centerText}>{title}</IonCardTitle>
                  <IonCardSubtitle style={subtitleStyle}>
                    <IonIcon src={Satoshi} style={marginRight5} />
                    {subtitle}
                  </IonCardSubtitle>
                </IonCol>
              </IonRow>
              <IonRow>
                <IonText
                  style={{ width: "100%" }}
                  color={
                    invoice?.data?.data?.status === "paid"
                      ? "success"
                      : "danger"
                  }
                >
                  <h1>
                    {!invoice?.data?.data?.status ? (
                      <small>Checking...</small>
                    ) : invoice?.data?.data?.status === "paid" ? (
                      "Paid"
                    ) : (
                      "Unpaid"
                    )}
                  </h1>
                </IonText>
              </IonRow>
            </IonGrid>
          </div>
        )}
      </div>
    </IonPage>
  );
};

export default QRCodeModal;
